import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { createSaveAddress, deleteAddress } from '../../../actions/address'

// Components
import Phone from '../../../shared/components/Phone'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'

import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Text from '../../../shared/elements/text'
import Button from '../../../shared/elements/button'

// Utils
import { translation } from '../../../utils/helpers'

class AddressesCreate extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      address: {
        CustomerClientId: 0,
        Name: '',
        Address: '',
        City: '',
        ZipCode: '',
        PhoneNumber: '',
        PhoneCode: this.props.phonecode
      },
      confirm: {
        open: false,
        type: 0
      },
      confirmDelete: {
        open: false
      }
    }
    this.inputChange = this.inputChange.bind(this)
    this.saveAddress = this.saveAddress.bind(this)
    this.deleteAddress = this.deleteAddress.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  resetCreate () {
    this.setState({
      type: 'create',
      address: {
        CustomerClientId: 0,
        Name: '',
        Address: '',
        City: '',
        ZipCode: '',
        PhoneNumber: '',
        PhoneCode: this.props.phonecode,
        CompanyDepartment: this.props.auth.departmentType
      }
    })
  }

  componentDidMount () {
    if (typeof this.props.item.CustomerClientId === 'undefined') {
      this.resetCreate()
    } else {
      this.setState({
        type: 'edit',
        address: this.props.item
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (typeof nextProps.item.CustomerClientId === 'undefined') {
      this.resetCreate()
    } else {
      this.setState({
        type: 'edit',
        address: nextProps.item
      })
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value

    if (e.target.type === 'radio') {
      value = (e.target.value === 'yes')
    }
    this.setState({
      // type: 'edit',
      address: {
        ...this.state.address,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'radio') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    if (this.state.address.CustomerClientId !== undefined && this.state.address.CustomerClientId !== 0) {
      this.saveAddress()
    }
  }

  inputChange (e) {
    let value = e.target.value
    if (e.target.name === 'PhoneCode') {
      value = {
        Id: e.target.value
      }
    }
    this.setState({
      address: {
        ...this.state.address,
        [e.target.name]: value
      }
    })
  }

  saveAddress () {
    this.props.createSaveAddress(this.state.address).then((res) => {
      this.props.onSave(res.data, this.state.type)
    }, (err) => {
      if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
        let errors = err.response.data.Errors
        let errorText = ''
        errors.map((item) => {
          if (item.DictionaryKey !== 0) {
            errorText += '<br />' + translation(item.DictionaryKey)
          }
        })
        // Toastr
        window.toastr.error(translation(errorText), translation('216'))
      } else {
        // Toastr
        window.toastr.error(translation('13468'), translation('216'))
      }
    })
  }

  deleteAddress () {
    this.setState({
      confirmDelete: {
        open: true
      }
    })
  }

  render () {
    return (
      <Row>
        <Col>
          <Panel title={translation('13420')} helpText={translation('1941')}>
            <Text name='Name' value={this.state.address.Name} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('30')} />
            <Text name='Address' value={this.state.address.Address} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('25')} />
            <Text name='ZipCode' value={this.state.address.ZipCode} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('40')} />
            <Text name='City' value={this.state.address.City} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('37')} />

            <LabelWrapper labelText={translation('345')}>
              <Phone
                onChange={this.inputChange}
                code={this.state.address.PhoneCode}
                number={this.state.address.PhoneNumber} />
            </LabelWrapper>

            {/* this.state.type === 'edit' && <button className='button full primary' onClick={this.saveAddress}>{translation('791')}</button> */}
            {/* {this.state.type === 'edit' && <button className='button full delete' onClick={this.deleteAddress}>{translation('786')}</button>} */}
            {this.state.type === 'edit' && <Button style='alert' onClick={this.deleteAddress} labelText={translation('786')} />}
          </Panel>
        </Col>

        {this.state.confirmDelete.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDelete')}>
            <Confirm confirm={this.onConfirm.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDelete')} />
          </Portal>
        )}
      </Row>
    )
  }

  onConfirm () {
    this.onPortalClose('confirmDelete')

    this.props.deleteAddress({
      ItemID: this.state.address.CustomerClientId
    }).then((res) => {
      this.props.onDelete(res.data)
    }, () => {
      // Toastr
      window.toastr.error(translation('13469'), translation('216'))
    })
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
  }
}

AddressesCreate.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode
  }
}

export default connect(mapStateToProps, { createSaveAddress, deleteAddress }, null, { withRef: true })(AddressesCreate)



// WEBPACK FOOTER //
// ./src/app/pages/Addresses/Create/index.js